import { Route } from '@angular/router';
import { authGuard, permissionGuard } from '@com.maessa.payroll.frontend/auth';
import { GestionLayoutComponent } from './layout/gestion-layout.component';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: GestionLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'work-sheets',
        canActivate: [permissionGuard],
        data: { permission: 'worksheet.view' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/work-sheets/list/work-sheets-list.component').then(
                (m) => m.WorkSheetsListComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/work-sheets/detail/work-sheet-detail.component').then(
                (m) => m.WorkSheetDetailComponent
              ),
          },
        ],
      },
      {
        path: 'reports',
        canActivate: [permissionGuard],
        data: { permission: 'reports.view' },
        loadComponent: () =>
          import('./features/reports/reports.component').then((m) => m.ReportsComponent),
      },
      {
        path: 'hours-database',
        canActivate: [permissionGuard],
        data: { permission: 'worksheet.view' },
        loadComponent: () =>
          import('./features/hours-database/hours-database.component').then(
            (m) => m.HoursDatabaseComponent
          ),
      },
      {
        path: 'employees',
        canActivate: [permissionGuard],
        data: { permission: 'employees.view' },
        loadComponent: () =>
          import('./features/employees/employees.component').then((m) => m.EmployeesComponent),
      },
      {
        path: 'oott',
        canActivate: [permissionGuard],
        data: { permission: 'oott.view' },
        loadComponent: () =>
          import('./features/oott/oott.component').then((m) => m.OottComponent),
      },
      {
        path: 'admin',
        canActivate: [permissionGuard],
        data: { role: 'administrator' },
        loadComponent: () =>
          import('./features/admin/admin.component').then((m) => m.AdminComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
